import { useEffect, useState } from "react";
import { Button, Dropdown, Flex, Typography } from "antd"; // Add Modal and Input import
import Helper from "../utils/helper";
import CreateForm from "./CreateForm";
import { UserOutlined } from "@ant-design/icons";
import ResetPasswordForm from "./ResetPasswordForm";

const Navbar = ({ onAddCustomer }) => {
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [isResetPasswordVisible, setIsResetPasswordVisible] = useState(false);
  const [dealerName, setDealerName] = useState(
    localStorage.getItem("dealer_name") || ""
  );

  const handleAddCustomer = () => {
    if (typeof onAddCustomer === "function") {
      // If onAddCustomer prop is provided, use it (existing logic)
      onAddCustomer();
    } else {
      // If not, open the CreateForm modal
      setIsCreateModalVisible(true);
    }
  };

  const handleResetPassword = () => {
    setIsResetPasswordVisible(true); // Show reset password modal
  };

  const handleResetPasswordOk = () => {
    setIsResetPasswordVisible(false);
  };

  const handleResetPasswordCancel = () => {
    setIsResetPasswordVisible(false); // Close modal
  };

  const profileMenuOptions = [
    {
      key: "dealer-name",
      label: (
        <Typography.Paragraph
          style={{ margin: 0 }}
        >{`Dealer Name: ${dealerName}`}</Typography.Paragraph>
      ),
    },
    {
      key: "reset-password",
      label: (
        <Typography.Paragraph
          onClick={handleResetPassword}
          style={{ margin: 0 }}
        >
          Reset Password
        </Typography.Paragraph>
      ),
    },
    {
      key: "logout",
      label: (
        <Typography.Paragraph
          onClick={Helper.handleLogout}
          style={{ margin: 0 }}
        >
          Logout
        </Typography.Paragraph>
      ),
    },
  ];

  useEffect(() => {
    const handleStorageChange = () => {
      const dealerName = localStorage.getItem("dealer_name");
      if (dealerName) {
        setDealerName(dealerName);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  return (
    <>
      <Flex
        mode="horizontal"
        justify="space-between"
        align="center"
        style={{
          padding: "4px 16px",
          borderBottom: "1px solid rgba(5, 5, 5, 0.06)",
        }}
      >
        <Typography.Title style={{ margin: 0 }} level={4}>
          <img
            src="./logo.svg"
            alt="MGSelect Logo"
            className="login-logo"
            style={{
              width: "fit-content",
              display: "block",
              objectFit: "contain",
            }}
          />
        </Typography.Title>
        <Flex align="center" gap={16}>
          <Button onClick={handleAddCustomer}>Add Customer</Button>
          <Dropdown trigger={["click"]} menu={{ items: profileMenuOptions }}>
            <Button icon={<UserOutlined />} />
          </Dropdown>
        </Flex>
      </Flex>

      {isCreateModalVisible && (
        <CreateForm
          isVisible={isCreateModalVisible}
          onClose={() => setIsCreateModalVisible(false)}
        />
      )}

      <ResetPasswordForm
        visible={isResetPasswordVisible}
        onOk={handleResetPasswordOk}
        onCancel={handleResetPasswordCancel}
      />
    </>
  );
};

export default Navbar;
